import { Component, EventEmitter, Input, OnInit, Output, NgModule, Inject, AfterViewInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';

import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'hotline-component',
  templateUrl: '../sharedTemplates/hotline.component.html',
})
export class HotlineComponent implements OnInit {
  casinoList = [];
  gameTypes = [];

  selectedCasinoType = 0;

  constructor(
    private _ApiService: ApiService,
    private _UiHelper: UiHelper,
    private _UserHelper: UserHelper,
    private _LocalizationService: LocalizationService,
    private _router: Router,

    private domSanitizer: DomSanitizer
  ) {}
  iframesrc;
  windowsH = 500;
  ngOnInit() {
    this.iframesrc = this.domSanitizer.bypassSecurityTrustResourceUrl('https://tawk.to/chat/5fcd170f920fc91564ce018c/default');
    this.windowsH = this._UiHelper.windowsHeight - 130;
    this._UiHelper.setLoadingDialog(true);
  }

  paymentpageLoaded() {
    this._UiHelper.setLoadingDialog(false);
  }
}
